import React, {Component} from 'react';
import './styles.css';

export default class AppMainMenu extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {className, toggle , isOpen} = this.props;

        return <>
            {
                toggle ? toggle : ''
            }

            <ul className={`app-main-menu-wrapper ${isOpen ? 'is-active' : ''} ${className ? className : ''}`}>

                {this.props.children}
            </ul>
        </>;
    }

}
